import React from 'react';
export function Footer() {
  return <footer className="py-5 px-4 sm:px-6 bg-anthracite text-center text-white/70 text-[10.5px] sm:text-xs" data-id="element-59" data-mp="32wd2qgad7ltj">
      <p className="font-semibold mb-1.5" data-id="element-60" data-mp="3ggkal1dq1o2p">
        © 2026 RUNNING COACH PRO™ — Tutti i Diritti Riservati.
      </p>
      <p className="leading-relaxed max-w-3xl mx-auto mb-2.5" data-id="element-61" data-mp="32m1ch24t96q7">
        Le informazioni contenute in questo sistema rappresentano materiale
        professionale di supporto per running coach, personal trainer e
        preparatori atletici. Non sostituiscono il giudizio professionale
        dell'allenatore, una valutazione sanitaria o eventuali indicazioni
        mediche. Ogni programma, sessione, test o protocollo deve essere adattato
        al livello di preparazione, alle condizioni fisiche, agli obiettivi e alle
        esigenze individuali di ciascun atleta.
      </p>
      <div className="flex justify-center items-center gap-2 font-semibold" data-id="element-62" data-mp="2a19tpmiidoxa">
        <a href="#" className="hover:text-gold transition-colors" data-id="element-63" data-mp="2ez1nyn6mln4n">
          Termini e Condizioni
        </a>
        <span data-id="element-64" data-mp="3l9sj15twaup0">•</span>
        <a href="#" className="hover:text-gold transition-colors" data-id="element-65" data-mp="3lbddkvg7mdmv">
          Privacy Policy
        </a>
        <span data-id="element-66" data-mp="3gctnciul2fop">•</span>
        <a href="#" className="hover:text-gold transition-colors" data-id="element-67" data-mp="3v89cc9gb3le8">
          Contatti
        </a>
      </div>
    </footer>;
}